<div class="esf-main-layout esf-main-layout--has-header esf-main-layout--has-inner-sidebar" [ngClass]="{'': innerSidebarRouterLinks.includes(router.url)}">
  <router-outlet></router-outlet>
</div>
